import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';

import { useDispatch } from 'react-redux';

import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { handlePostRequest } from '../../service/PostTemplate';

const ContactDetails = () => {
    const [allRoles, setAllRoles] = useState([]);
    const [viewable, setViewable] = useState(false);

    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();
    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerName: '',
            phoneNumber: '',
            consumerId: '',
            dateOfBirth: '',
            cnic: '',
            gender: '',
            emailAddress: '',
            address: '',
            profileImageBase64: '',
            profileImagePath: '',
            createdBy: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            setLoadingBtn(true);
            const addData = {
                roleName: data.roleName,
                createdBy: user?.user?.userId
            };

            const editData = {
                id: data.id,
                roleName: data.roleName,
                modifiedBy: user?.user?.userId
            };

            const response = await dispatch(handlePostRequest(addData, endPoints.addRole, true));
            if (response?.status === 200) {
                formik.resetForm();
                //   onHide();
            }
            setLoadingBtn(false);
        }
    });

    // const handleAdd = () => {
    //     setShowAddDialog(true);
    //     setEditable(false);
    //     setViewable(false);
    // };

    // const handleEdit = (rowData) => {
    //     setShowAddDialog(true);
    //     setEditable(true);
    //     setViewable(false);
    //     setRowRecord(rowData);
    // };

    // const handleView = (rowData) => {
    //     setShowAddDialog(true);
    //     setEditable(false);
    //     setViewable(true);
    //     setRowRecord(rowData);
    // };

    // const handleInputSwitch = async () => {
    //     setLoadingBtn(true);

    //     let data = {
    //         isActive: switchData?.isActive ? false : true
    //     };

    //     const response = await dispatch(handlePutRequest(data, endPoints?.updateRole, false, true));

    //     if (response?.status === 200) {
    //         getRoleList();
    //     }

    //     setLoadingBtn(false);
    //     handleSwitchModalClose();
    // };

    // const handleSwitchModalOpen = () => {
    //     setSwitchModal(true);
    // };

    // const handleSwitchModalClose = () => {
    //     setSwitchModal(false);
    // };

    // const actionBodyTemplate = (rowData) => {
    //     return (
    //         <>
    //             <div className="actions">
    //                 <InputSwitch
    //                     tooltip="Status"
    //                     tooltipOptions={{ position: 'top' }}
    //                     checked={rowData.isActive}
    //                     onChange={() => {
    //                         handleSwitchModalOpen();
    //                         setSwitchData(rowData);
    //                     }}
    //                 />

    //                 <Button
    //                     tooltip="Edit"
    //                     icon="pi pi-pencil"
    //                     tooltipOptions={{ position: 'top' }}
    //                     disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
    //                     onClick={() => {
    //                         handleEdit(rowData);
    //                     }}
    //                     className="p-button-rounded p-button-primary mr-2 ml-2"
    //                 />
    //                 <Button
    //                     tooltip="View"
    //                     tooltipOptions={{ position: 'top' }}
    //                     icon="pi pi-eye"
    //                     onClick={() => {
    //                         handleView(rowData);
    //                     }}
    //                     className="p-button-rounded"
    //                     style={{ backgroundColor: '#F2AC57', border: 'none' }}
    //                 />
    //             </div>
    //         </>
    //     );
    // };

    const getRoleList = async () => {
        const response = await handleGetRequest(endPoints.getallRoles, true, false, dispatch);
        if (response) {
            setAllRoles(response);
        }
    };

    useEffect(() => {
        getRoleList();
    }, []);

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Contact Details</h3>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="p-field col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="Department">Department</label>
                                <Dropdown id="department" type="department" name="department" placeholder="Select Department" max={50} value={formik?.values?.department || ''} onChange={formik.handleChange} />
                                {formik.touched.department && formik.errors.department && <small className="p-error">{formik.errors.department}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="field">
                                <label htmlFor="EmailAddress">Email Address</label>
                                <InputText id="EmailAddress" name="EmailAddress" placeholder="Enter Email" max={50} value={formik?.values?.emailAddress || ''} onChange={formik.handleChange} />
                                {formik.touched.emailAddress && formik.errors.emailAddress && <small className="p-error">{formik.errors.emailAddress}</small>}
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            {/* <Button disabled={loading} loadingIcon={loadingIcon} icon={loadingIcon} iconPos="left" label="Search" className="Btn__Dark__Search" /> */}
                            <Button label="Submit" className="Btn__Dark__Search" />

                            <Button
                                label="Reset"
                                // onClick={(e) => resetHandle(e)}
                                className="Btn__Transparent__Reset"
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="Form__Header mt-5">
                <p className="text-2xl font-medium">Merchant Emails</p>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            emptyMessage="No data available in table"
                            responsiveLayout="scroll"
                            value={[]} // Replace with your actual data
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="departmentName" header="Department Name" />
                            <Column field="departmentDescription" header="Department Description" sortable />
                            <Column field="emailAddress" header="Email Address" />
                            <Column header="Remove" body={() => <button className="btn btn-danger btn-sm">Remove</button>} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactDetails;
